// // // src/App.jsx
// // import React from "react";
// // import ClippedSection from "./ClipPath";
// // // import Hero from "./Hero";

// // function App() {
// //   return (
// //     <div className="App">
// //       {/* <Hero /> */}
// //       {/* <div style={{ height: "200vh", backgroundColor: "#eef2f5" }}> */}
// //         {/* extra scroll area */}
// //       {/* </div> */}
// //       <ClippedSection />
// //       <ClippedSection />


// //       {/* Hidden SVG for Multiple ClipPaths */}
// //       <svg className="">
// //         {/* Mobile Shape */}
// //         <clipPath id="clip-mobile" clipPathUnits="objectBoundingBox">
// //           <path d="M1 0.35C1 0.4 0.97 0.45 0.94 0.45H0.1C0.05 0.45 0 0.5 0 0.55V1H0.9C0.95 1 1 0.95 1 0.9V0.35Z" />
// //         </clipPath>

// //         {/* Tablet Shape */}
// //         <clipPath id="clip-tablet" clipPathUnits="objectBoundingBox">
// //           <path d="M1 0.3C1 0.36 0.98 0.4 0.95 0.4H0.12C0.08 0.4 0.05 0.45 0.05 0.5V1H0.95C0.98 1 1 0.95 1 0.9V0.3Z" />
// //         </clipPath>

// //         {/* Desktop Shape */}
// //         <clipPath id="clip-desktop" clipPathUnits="objectBoundingBox">
// //           <path d="M1 0.313C1 0.354 0.987 0.389 0.971 0.389H0.911C0.895 0.389 0.881 0.423 0.881 0.465V0.923C0.881 0.965 0.867 1 0.849 1H0.028C0.013 1 0 0.965 0 0.923V0.078C0 0.035 0.013 0 0.028 0H0.733C0.749 0 0.763 0.037 0.77 0.075C0.782 0.126 0.805 0.162 0.83 0.162C0.856 0.162 0.878 0.126 0.89 0.075C0.897 0.037 0.911 0 0.927 0H0.971C0.987 0 1 0.035 1 0.078V0.313Z" />
// //         </clipPath>
// //       </svg>
// //     </div>
// //   );
// // }

// // export default App;



import React, { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Home from './pages/Home/Home'
import ScrollToTop from './ScrollToTop'
import Navbar from './components/Header/Navbar'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactUs from './pages/Contact/ContactUs'
import AboutUs from './pages/About/AboutUs'
import OurFleet from './pages/Fleet/OurFleet'
import Training from './pages/Training/Training'
import Footer from './components/Footer/Footer'

export default function App() {

  const [isBackgroundBlurred, setIsBackgroundBlurred] = useState(false);

  return (
    <div>
      <Navbar setBackgroundBlur={setIsBackgroundBlurred} />
      <div id="background" className={`pt-12 ${isBackgroundBlurred ? '' : ''}`}>
        <ScrollToTop />
        <Routes>
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/contact-us'
            element={<ContactUs />}
          />
          <Route
            path='/about-us'
            element={<AboutUs />}
          />
          <Route
            path='/our-fleet'
            element={<OurFleet />}
          />
          <Route
            path='/training'
            element={<Training />}
          />
          <Route
            path="*"
            element={<Navigate to="/" />}
          />
        </Routes>
        <Footer />
      </div>
    </div>
  )
}




// import React, { useState, useRef, useMemo, useEffect } from 'react';
// import { Canvas, useFrame, useThree } from '@react-three/fiber';
// import { OrbitControls, useGLTF, Stage } from '@react-three/drei';
// import { animated, useSpring } from '@react-spring/three';
// import * as THREE from 'three';
// import './index.css';

// const aircrafts = [
//   {
//     name: 'Aircraft One',
//     details: 'This is the first aircraft. Some details about it.',
//     modelPath: '/models/cessna-172.glb',
//   },
//   {
//     name: 'Aircraft Two',
//     details: 'Second aircraft – faster, sleeker.',
//     modelPath: '/models/piper.glb',
//   },
//   {
//     name: 'Aircraft Three',
//     details: 'Third aircraft – private jet style.',
//     modelPath: '/models/beechcraft.glb',
//   },
// ];

// function AircraftModel({ modelPath }) {
//   const gltf = useGLTF(modelPath, true);
//   return <primitive object={gltf.scene} />;
// }

// function Scene({ modelPath }) {
//   const groupRef = useRef();

//   useFrame((state, delta) => {
//     if (groupRef.current) {
//       groupRef.current.rotation.y += delta * 0.2;
//     }
//   });

//   return (
//     <Stage environment="city" intensity={0.6}>
//       <group ref={groupRef} scale={1}>
//         <AircraftModel modelPath={modelPath} />
//       </group>
//     </Stage>
//   );
// }

// // Custom camera + controls rig to ensure target is a Vector3 and can animate
// function CameraRig({ camPosition, targetPosition }) {
//   const { camera, gl } = useThree();
//   const controlsRef = useRef();

//   // Animate camera position & target via react-spring
//   useEffect(() => {
//     camera.position.set(camPosition[0], camPosition[1], camPosition[2]);
//   }, [camPosition, camera]);

//   useEffect(() => {
//     if (controlsRef.current) {
//       controlsRef.current.target.set(
//         targetPosition[0],
//         targetPosition[1],
//         targetPosition[2]
//       );
//       controlsRef.current.update();
//     }
//   }, [targetPosition]);

//   useFrame(() => {
//     controlsRef.current?.update();
//   });

//   return <OrbitControls ref={controlsRef} args={[camera, gl.domElement]} enableDamping />;
// }

// export default function App() {
//   const [index, setIndex] = useState(0);
//   const { name, details, modelPath } = aircrafts[index];

//   // Define the camera and target positions; you can change them per aircraft if desired
//   const camPos = useMemo(() => [0, 2, 5], []);
//   const targetPos = useMemo(() => [0, 0, 0], []);

//   const next = () => setIndex((i) => (i + 1) % aircrafts.length);
//   const prev = () => setIndex((i) => (i - 1 + aircrafts.length) % aircrafts.length);

//   return (
//     <div className="flex flex-col h-screen">
//       <div className="flex-none p-4 bg-gray-800 text-white">
//         <h1 className="text-xl font-bold">{name}</h1>
//         <p className="mt-1">{details}</p>
//         <div className="mt-4 space-x-2">
//           <button className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500" onClick={prev}>
//             Previous
//           </button>
//           <button className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500" onClick={next}>
//             Next
//           </button>
//         </div>
//       </div>
//       <div className="flex-1">
//         <Canvas camera={{ position: camPos, fov: 45 }}>
//           <CameraRig camPosition={camPos} targetPosition={targetPos} />
//           <ambientLight intensity={0.4} />
//           <directionalLight position={[5, 10, 7]} intensity={1} />
//           <Scene key={modelPath} modelPath={modelPath} />
//         </Canvas>
//       </div>
//     </div>
//   );
// }








// import React, { useState, useRef, useMemo, useEffect } from 'react';
// import { Canvas, useFrame, useThree } from '@react-three/fiber';
// import { OrbitControls, useGLTF, Stage } from '@react-three/drei';
// import * as THREE from 'three';
// import './index.css';

// const aircrafts = [
//   {
//     name: 'Aircraft One',
//     details: 'This is the first aircraft. Some details about it.',
//     modelPath: '/models/cessna-172.glb',
//     hotspots: [],     // no hotspots
//   },
//   {
//     name: 'Aircraft Two',
//     details: 'Second aircraft – faster, sleeker.',
//     modelPath: '/models/piper.glb',
//     hotspots: [],     // no hotspots
//   },
//   {
//     name: 'Aircraft Three',
//     details: 'Third aircraft – private jet style.',
//     modelPath: '/models/beechcraft.glb',
//     hotspots: [
//       {
//         name: 'Cockpit',
//         meshName: 'CockpitMesh',        // replace with actual mesh name
//         info: 'This is the cockpit area with avionics & pilot seats.'
//       },
//       {
//         name: 'Engine',
//         meshName: 'EngineMesh',         // replace with actual mesh name
//         info: 'Twin-turbofan engine, capable of …'
//       },
//       {
//         name: 'WingTip',
//         meshName: 'WingTipMesh',        // replace with actual mesh name
//         info: 'Wing tip with winglet for efficient cruise.'
//       },
//     ],
//   },
// ];

// // Component to render hotspots (as small spheres) and handle click
// function Hotspot({ position, onClick, label }) {
//   return (
//     <mesh position={position} onClick={onClick}>
//       <sphereGeometry args={[0.05, 16, 16]} />
//       <meshBasicMaterial color="red" />
//       {/* Optionally we can add a label with <Html> from drei */}
//     </mesh>
//   );
// }

// // function AircraftModel({ modelPath, hotspots, setHotspotInfo }) {
// //   const { scene, nodes } = useGLTF(modelPath);
// //   const groupRef = useRef();

// //   // After mount, we can find meshes and compute hotspot positions
// //   const hotspotComponents = useMemo(() => {
// //     if (!hotspots || hotspots.length === 0) return null;

// //     return hotspots.map((hs, i) => {
// //       const mesh = nodes[hs.meshName];
// //       if (!mesh) {
// //         console.warn(`Mesh name ${hs.meshName} not found in GLTF nodes`);
// //         return null;
// //       }
// //       // world position of that mesh for hotspot placement
// //       const pos = new THREE.Vector3();
// //       mesh.getWorldPosition(pos);
// //       return (
// //         <Hotspot
// //           key={i}
// //           label={hs.name}
// //           position={[pos.x, pos.y, pos.z]}
// //           onClick={() => {
// //             setHotspotInfo({ name: hs.name, info: hs.info });
// //           }}
// //         />
// //       );
// //     });
// //   }, [hotspots, nodes, setHotspotInfo]);

// //   useFrame((state, delta) => {
// //     if (groupRef.current) {
// //       groupRef.current.rotation.y += delta * 0.2;
// //     }
// //   });

// //   return (
// //     <group ref={groupRef} dispose={null} scale={1}>
// //       <primitive object={scene} />
// //       {hotspotComponents}
// //     </group>
// //   );
// // }


// function AircraftModel({ modelPath, hotspots, setHotspotInfo }) {
//   const { scene, nodes } = useGLTF(modelPath);
//   const groupRef = useRef();

//   useEffect(() => {
//     console.log("Loaded nodes:", Object.keys(nodes));
//   }, [nodes]);

//   const hotspotComponents = (hotspots || []).map((hs, i) => {
//     const mesh = nodes[hs.meshName];
//     if (!mesh) {
//       console.warn(`Mesh name ${hs.meshName} not found in GLTF nodes`);
//       return null;
//     }
//     const pos = new THREE.Vector3();
//     mesh.getWorldPosition(pos);
//     // maybe offset outward a little
//     pos.y += 0.1;
//     return (
//       <mesh
//         key={i}
//         position={[pos.x, pos.y, pos.z]}
//         onClick={() => setHotspotInfo({ name: hs.name, info: hs.info })}
//       >
//         <sphereGeometry args={[1, 16, 16]} /> {/* larger size */}
//         <meshBasicMaterial color="red" depthTest={false} depthWrite={false} />
//       </mesh>
//     );
//   });

//   useFrame((state, delta) => {
//     if (groupRef.current) groupRef.current.rotation.y += delta * 0.2;
//   });

//   return (
//     <group ref={groupRef} dispose={null} scale={1}>
//       <primitive object={scene} />
//       {hotspotComponents}
//     </group>
//   );
// }

// function Scene({ modelPath, hotspots, setHotspotInfo }) {
//   return (
//     <Stage environment="city" intensity={0.6}>
//       <AircraftModel modelPath={modelPath} hotspots={hotspots} setHotspotInfo={setHotspotInfo} />
//     </Stage>
//   );
// }

// function CameraRig({ camPosition, targetPosition }) {
//   const { camera, gl } = useThree();
//   const controlsRef = useRef();

//   useEffect(() => {
//     camera.position.set(camPosition[0], camPosition[1], camPosition[2]);
//   }, [camPosition, camera]);

//   useEffect(() => {
//     if (controlsRef.current) {
//       controlsRef.current.target.set(targetPosition[0], targetPosition[1], targetPosition[2]);
//       controlsRef.current.update();
//     }
//   }, [targetPosition]);

//   useFrame(() => {
//     controlsRef.current?.update();
//   });

//   return <OrbitControls ref={controlsRef} args={[camera, gl.domElement]} enableDamping />;
// }

// export default function App() {
//   const [index, setIndex] = useState(0);
//   const [hotspotInfo, setHotspotInfo] = useState(null);
//   const { name, details, modelPath, hotspots } = aircrafts[index];

//   const camPos = useMemo(() => [0, 2, 5], []);
//   const targetPos = useMemo(() => [0, 0, 0], []);

//   const next = () => {
//     setHotspotInfo(null);
//     setIndex((i) => (i + 1) % aircrafts.length);
//   };
//   const prev = () => {
//     setHotspotInfo(null);
//     setIndex((i) => (i - 1 + aircrafts.length) % aircrafts.length);
//   };

//   return (
//     <div className="flex flex-col h-screen">
//       <div className="flex-none p-4 bg-gray-800 text-white">
//         <h1 className="text-xl font-bold">{name}</h1>
//         <p className="mt-1">{details}</p>
//         <div className="mt-4 space-x-2">
//           <button
//             className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500"
//             onClick={prev}
//           >
//             Previous
//           </button>
//           <button
//             className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500"
//             onClick={next}
//           >
//             Next
//           </button>
//         </div>
//         {hotspotInfo && (
//           <div className="mt-4 p-2 bg-gray-700 rounded">
//             <h2 className="font-semibold">{hotspotInfo.name}</h2>
//             <p className="mt-1">{hotspotInfo.info}</p>
//           </div>
//         )}
//       </div>
//       <div className="flex-1">
//         <Canvas camera={{ position: camPos, fov: 45 }}>
//           <CameraRig camPosition={camPos} targetPosition={targetPos} />
//           <ambientLight intensity={0.4} />
//           <directionalLight position={[5, 10, 7]} intensity={1} />
//           <Scene key={modelPath} modelPath={modelPath} hotspots={hotspots} setHotspotInfo={setHotspotInfo} />
//         </Canvas>
//       </div>
//     </div>
//   );
// }





// // App.jsx
// import React, { useState, useRef, useMemo, useEffect, Suspense } from 'react';
// import { Canvas, useFrame, useThree } from '@react-three/fiber';
// import { OrbitControls, useGLTF, Stage } from '@react-three/drei';
// import * as THREE from 'three';
// import './index.css';

// const aircrafts = [
//   {
//     name: 'Aircraft One',
//     details: 'This is the first aircraft. Some details about it.',
//     modelPath: '/models/cessna-172.glb',
//     hotspots: [],
//   },
//   {
//     name: 'Aircraft Two',
//     details: 'Second aircraft – faster, sleeker.',
//     modelPath: '/models/piper.glb',
//     hotspots: [],
//   },
//   {
//     name: 'Aircraft Three',
//     details: 'Third aircraft – private jet style.',
//     modelPath: '/models/beechcraft.glb',
//     hotspots: [
//       { name: 'Cockpit', meshName: 'Object_2', info: 'This is the cockpit area with avionics & pilot seats.' },
//       { name: 'Engine', meshName: 'Object_13', info: 'Twin-turbofan engine, capable of …' },
//       { name: 'WingTip', meshName: 'Object_14', info: 'Wing tip with winglet for efficient cruise.' },
//     ],
//   },
// ];

// function Hotspot({ position, onClick, label }) {
//   return (
//     <mesh position={position} onClick={onClick}>
//       <sphereGeometry args={[0.1, 16, 16]} />
//       <meshBasicMaterial color="red" depthTest={false} depthWrite={false} />
//     </mesh>
//   );
// }

// function AircraftModel({ modelPath, hotspots, setHotspotInfo }) {
//   const { scene, nodes } = useGLTF(modelPath, true);
//   const groupRef = useRef();

//   useEffect(() => {
//     console.log('Loaded nodes names:', Object.keys(nodes));
//   }, [nodes]);

//   const hotspotComponents = useMemo(() => {
//     if (!hotspots || hotspots.length === 0) return null;
//     return hotspots.map((hs, i) => {
//       const mesh = nodes[hs.meshName];
//       if (!mesh) {
//         console.warn(`Mesh name ${hs.meshName} not found in GLTF nodes`);
//         return null;
//       }
//       const pos = new THREE.Vector3();
//       mesh.getWorldPosition(pos);
//       pos.y += 0.1; // offset slightly upward
//       return (
//         <Hotspot
//           key={i}
//           label={hs.name}
//           position={[pos.x, pos.y, pos.z]}
//           onClick={() => setHotspotInfo({ name: hs.name, info: hs.info })}
//         />
//       );
//     });
//   }, [hotspots, nodes, setHotspotInfo]);

//   useFrame((state, delta) => {
//     if (groupRef.current) {
//       groupRef.current.rotation.y += delta * 0.2;
//     }
//   });

//   return (
//     <group ref={groupRef} dispose={null} scale={1}>
//       <primitive object={scene} />
//       {hotspotComponents}
//     </group>
//   );
// }

// function Scene({ modelPath, hotspots, setHotspotInfo }) {
//   return (
//     <Stage environment="city" intensity={0.6}>
//       <AircraftModel modelPath={modelPath} hotspots={hotspots} setHotspotInfo={setHotspotInfo} />
//     </Stage>
//   );
// }

// function CameraRig({ camPosition, targetPosition }) {
//   const { camera, gl } = useThree();
//   const controlsRef = useRef();

//   useEffect(() => {
//     camera.position.set(camPosition[0], camPosition[1], camPosition[2]);
//   }, [camPosition, camera]);

//   useEffect(() => {
//     if (controlsRef.current) {
//       controlsRef.current.target.set(targetPosition[0], targetPosition[1], targetPosition[2]);
//       controlsRef.current.update();
//     }
//   }, [targetPosition]);

//   useFrame(() => {
//     controlsRef.current?.update();
//   });

//   return <OrbitControls ref={controlsRef} args={[camera, gl.domElement]} enableDamping />;
// }

// export default function App() {
//   const [index, setIndex] = useState(0);
//   const [hotspotInfo, setHotspotInfo] = useState(null);

//   const { name, details, modelPath, hotspots } = aircrafts[index];

//   const camPos = useMemo(() => [0, 2, 5], []);
//   const targetPos = useMemo(() => [0, 0, 0], []);

//   const next = () => {
//     setHotspotInfo(null);
//     setIndex((i) => (i + 1) % aircrafts.length);
//   };
//   const prev = () => {
//     setHotspotInfo(null);
//     setIndex((i) => (i - 1 + aircrafts.length) % aircrafts.length);
//   };

//   return (
//     <div className="flex flex-col h-screen">
//       <div className="flex-none p-4 bg-gray-800 text-white">
//         <h1 className="text-xl font-bold">{name}</h1>
//         <p className="mt-1">{details}</p>
//         <div className="mt-4 space-x-2">
//           <button className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500" onClick={prev}>
//             Previous
//           </button>
//           <button className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500" onClick={next}>
//             Next
//           </button>
//         </div>
//         {hotspotInfo && (
//           <div className="mt-4 p-2 bg-gray-700 rounded">
//             <h2 className="font-semibold">{hotspotInfo.name}</h2>
//             <p className="mt-1">{hotspotInfo.info}</p>
//           </div>
//         )}
//       </div>
//       <div className="flex-1">
//         <Canvas camera={{ position: camPos, fov: 45 }}>
//           <CameraRig camPosition={camPos} targetPosition={targetPos} />
//           <ambientLight intensity={0.4} />
//           <directionalLight position={[5, 10, 7]} intensity={1} />
//           <Suspense fallback={null}>
//             <Scene key={modelPath} modelPath={modelPath} hotspots={hotspots} setHotspotInfo={setHotspotInfo} />
//           </Suspense>
//         </Canvas>
//       </div>
//     </div>
//   );
// }
